var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-control custom-switch custom-switch--dark"},[_c('input',{staticClass:"custom-control-input cursor-pointer align-middle",attrs:{"type":"checkbox","id":_vm.name},domProps:{"value":_vm.value},on:{"input":_vm.change}}),_c('label',{staticClass:"custom-control-label cursor-pointer",attrs:{"for":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }